module.exports = "/static/assets/06fbea3e34c66462364944fc91a708c9.png";